import { render } from "./UserNotFound.vue?vue&type=template&id=5c62ec82&scoped=true"
import script from "./UserNotFound.vue?vue&type=script&lang=js"
export * from "./UserNotFound.vue?vue&type=script&lang=js"

import "./UserNotFound.vue?vue&type=style&index=0&id=5c62ec82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c62ec82"]])

export default __exports__